import React from 'react';

import svg from './assets/icons-16-star-circle-filled.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconStarCircleFilled = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-star-circle-filled" />
);
